import { WaterAdditionHistoryMessages, TranslationWaterAdditionHistoryMessages } from "../interfaces/waterAdditionHistoryMessages";

const waterAdditionHistoryMessages: TranslationWaterAdditionHistoryMessages = {
  [WaterAdditionHistoryMessages.title]: "Histórico de Adições de Água",
  [WaterAdditionHistoryMessages.waterAdditionHistory]: "Histórico de Adições de Água",
  [WaterAdditionHistoryMessages.filterTitle]: "Filtrar Histórico de Adições de Água",
  [WaterAdditionHistoryMessages.fleetCode]: "Frota",
  [WaterAdditionHistoryMessages.licensePlate]: "Placa",
  [WaterAdditionHistoryMessages.startDate]: "Data Início",
  [WaterAdditionHistoryMessages.finishDate]: "Data Fim",
  [WaterAdditionHistoryMessages.driver]: "Motorista",
  [WaterAdditionHistoryMessages.document]: "Doc.",
  [WaterAdditionHistoryMessages.vehicleState]: "Estado do Veículo",
  [WaterAdditionHistoryMessages.waterAdded]: "Água Adicionada (L)",
  [WaterAdditionHistoryMessages.moment]: "Momento",
  [WaterAdditionHistoryMessages.address]: "Endereço",
  [WaterAdditionHistoryMessages.preDischarge]: "Pré-Descarga",
  [WaterAdditionHistoryMessages.postDischarge]: "Pós-Descarga",
  [WaterAdditionHistoryMessages.noDataFound]: "Nenhum dado encontrado para o período selecionado"
};

export const messages = waterAdditionHistoryMessages;
